import addData from "@/firebase/firestore/addData";
import editData from "@/firebase/firestore/editData";
import { defaultDuration } from "@/components/defaults";

export const printStyle = (s, selector, bg, duration, animationType) => {
	duration = duration || "10s";
	animationType = animationType || "alternate";

	const props = [];
	const style = [];
	const style_flat = [];
	const defs = [];
	const anims = [];
	const blend = [];
	let is_flat = true;
	s.forEach((o, i) => {
		const _static = {};
		Object.keys(o).forEach((k) => {
			const key = k[0];

			if (o[k].length > 1) {
				is_flat = false;
				o[k].forEach((a, ai) => {
					if (!anims[ai]) anims[ai] = [];
					if (k === "spread") {
						const { start, end } = a;
						anims[ai].push(`--${key}-start-${i}:${start};`);
						anims[ai].push(`--${key}-end-${i}:${end};`);
					} else {
						anims[ai].push(`--${key}-${i}:${a};`);
					}
				});
			}
			const initialValue = o[k][0];

			const syntax = k === "colors" ? "<color>" : "<percentage>";
			if (k === "spread") {
				const { start, end } = initialValue;

				props.push(
					`@property --${key}-start-${i}{syntax:'${syntax}';inherits:false;initial-value:${start}}`
				);
				props.push(
					`@property --${key}-end-${i}{syntax:'${syntax}';inherits:false;initial-value:${end}}`
				);
				_static.spread_start = start;
				_static.spread_end = end;
			} else {
				if (k !== "blend") {
					props.push(
						`@property --${key}-${i}{syntax:'${syntax}';inherits:false;initial-value:${initialValue}}`
					);
					defs.push(`--${key}-${i}:${initialValue};`);
				} else {
					blend.push(initialValue);
				}
				_static[k] = initialValue;
			}
		});

		style.push(
			`radial-gradient(circle at var(--x-${i}) var(--y-${i}), var(--c-${i}) var(--s-start-${i}),transparent var(--s-end-${i}))`
		);
		style_flat.push(
			`radial-gradient(circle at ${_static.x} ${_static.y}, ${_static.colors} ${_static.spread_start},transparent ${_static.spread_end})`
		);
	});
	const printedAnims = [];
	if (anims.length > 0) {
		printedAnims.push(`@keyframes ani-${selector}{`);
		anims.forEach((an, i) => {
			const unit = parseInt(100 / (anims.length - 1));
			printedAnims.push(i * unit + "%{" + an.join(" ") + "}");
		});
		printedAnims.push("}");
	}

	//const realDuration = duration === 'prev' ? '1000s' : duration
	const prevDurationHover =
		duration === "prev"
			? `#${selector}:hover{animation:ani-${selector} ${defaultDuration} linear infinite ${animationType};}`
			: "";

	const printAnimation =
		duration === "prev"
			? prevDurationHover
			: `animation:ani-${selector} ${duration} linear infinite ${animationType}`;

	let rett = is_flat
		? [
				"#" + selector + "{",
				"background-color:" + bg + ";background-image:",
				style_flat.join(","),
				";background-blend-mode:" + blend.join(",") + ";}",
		  ]
		: [
				printedAnims.join(""),
				props.join(""),
				"#" +
					selector +
					"{" +
					defs.join("") +
					";background-color:" +
					bg +
					";background-image:" +
					style.join(",") +
					";",
				printAnimation,
				";background-blend-mode:" + blend.join(",") + ";}",
				prevDurationHover,
		  ];

	rett = rett.join("");

	return rett;
};
export function r(min, max) {
	return Math.floor(Math.random() * (max - min + 1) + min);
}

export function randomizer({ h, s, l }, points, steps) {
	const ret = [];

	const generator = () => {
		const colors = [];
		const x = [];
		const y = [];
		const spread = [];
		//const blend = [blendModes[r(0,blendModes.length - 1)]]
		const blend = ["normal"];
		for (let m = 0; m < steps; m++) {
			colors.push(
				`hsla(${r(h[0], h[1])},${r(s[0], s[1])}%,${r(l[0], l[1])}%,1)`
			);
			x.push(`${r(0, 100)}%`);
			y.push(`${r(0, 100)}%`);
			const spreadMin = r(0, 20);
			const spreadMax = r(50, 90);
			spread.push({ start: spreadMin + "%", end: spreadMax + "%" });
		}
		return { colors, x, y, spread, blend };
	};
	for (let m = 0; m < points; m++) {
		const { colors, x, y, spread, blend } = generator();
		ret.push({ colors, x, y, spread, blend });
	}
	const bg = `hsla(${r(h[0], h[1])},${r(s[0], s[1])}%,${r(l[0], l[1])}%,1)`;

	return { ret, bg };
}

export const deepCopy = (c) => JSON.parse(JSON.stringify(c));

export const saveMesh = (data, cb) => {
	const newMeshID = Date.now().toString();
	addData("mesh", newMeshID, data, cb);
};

export const locallySavedKey = "mesherLovedMeshes";

export const addLove = (id, newVal, cb) => {
	let locallySavedMeshes = localStorage.getItem(locallySavedKey) || "[]";
	locallySavedMeshes = JSON.parse(locallySavedMeshes);
	if (locallySavedMeshes.indexOf(id) === -1 || 1) {
		editData("mesh", id, { love: newVal });
		locallySavedMeshes.push(id);
		cb(newVal);
	}
	localStorage.setItem(locallySavedKey, JSON.stringify(locallySavedMeshes));
};

export const isLoved = (uid, love) => {
	return typeof love === "object" && love.indexOf(uid) > -1;
};

export const findMedianColor = (ob) => {
	const { config, bg } = ob;

	let allColors = [bg];
	config.forEach((c) =>
		c.colors.forEach((k) => (allColors = [...allColors, k]))
	);
	const le = allColors.length;
	const ret = { h: 0, s: 0, l: 0, a: 1 };
	allColors.forEach((c, i) => {
		let vals = c.split("(")[1];
		vals = vals.split(")")[0];
		vals = vals.split(",");
		let [h, s, l] = vals;
		ret.h = ret.h + parseInt(h);
		ret.s = ret.s + parseInt(s);
		ret.l = ret.l + parseInt(l);
		if (i === le - 1) {
			ret.h = parseInt(ret.h / le);
			ret.s = parseInt(ret.s / le);
			ret.l = parseInt(ret.l / le);
		}
	});
	return `hsla(${ret.h},${ret.s}%,${ret.l}%,${ret.a})`;
};

export const findObColors = (ob) => {
	const { config, bg } = ob;

	let allColors = [bg];
	config.forEach((c) =>
		c.colors.forEach((k) => (allColors = [...allColors, k]))
	);

	return allColors;
};

export const findIsAnimated = (ob) => {
	let isAnimated = false;
	ob.config.forEach((k) => {
		if (k.colors.length > 1) isAnimated = true;
	});
	return isAnimated;
};

export const validateString = (s) => s.replace(/[^\w\s.-]+/g, "");

export const getColorName = async (hsla) => {
	let hsl = hsla;
	hsl = hsl.substr(hsl.indexOf("(") + 1);
	hsl = hsl.substr(0, hsl.lastIndexOf(","));
	const [h, s, l] = hsl.split(",").map((z) => parseInt(z));
	hsl = `hsl(${h},${s}%,${l}%)`;

	const response = await fetch(
		`https://www.thecolorapi.com/id?hsl=${hsl}&format=json`
	);
	const k = await response.json();

	return k?.name?.value;
};
/* 
export const drawSVG = (canvasRef, send, pos) => {
	var c = canvasRef;
	var ctx = c.getContext("2d");

	const _x = (str) => (parseInt(str) * c.width) / 100;
	const _y = (str) => (parseInt(str) * c.height) / 100;

	ctx.fillStyle = send.bg;
	ctx.fillRect(0, 0, c.width, c.height);
	const revConfig = deepCopy(send.config).reverse();
	revConfig.forEach((l) => {
		const { spread, x, y, colors, blend } = l;
		pos = colors[pos] ? pos : 0;
		const startColor = colors[pos];
		const endColor = startColor.split(",1)").join(",0)");
		const __x = _x(x[pos]);
		const __y = _y(y[pos]);
		const _s = spread[pos];
		const __s = _x(_s.start);
		const __s2 = _x(_s.end);
		let rGrad = ctx.createRadialGradient(__x, __y, __s, __x, __y, __s2);
		rGrad.addColorStop(0, startColor);
		rGrad.addColorStop(1, endColor);
		ctx.fillStyle = rGrad;
		ctx.fillRect(0, 0, c.width, c.height);
	});
}; */
